import axios, { AxiosError } from 'axios';

import { ResponseTO } from '../types/response-to.type';
import { Coupon } from '../types/coupon.type';

import { handleResponseError } from './webservice';

const BASE_URL = process.env.REACT_APP_PAYMENTS_API_URL;
const TOKEN = process.env.REACT_APP_PANA_API_TOKEN;

const checkCouponCode = async (code: string): Promise<ResponseTO<Coupon>> => {
    try {
        const response = await axios.get<ResponseTO>(
            `${BASE_URL}/v1/coupons/codes/${code}`,
            { headers: { Authorization: `Bearer ${TOKEN}` } }
        );
        return response.data;
    } catch (err) {
        return handleResponseError(err as AxiosError);
    }
};

export const paymentsSDK = {
    checkCouponCode,
};
